/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react'
import { useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'react-bootstrap'
import Select from 'react-select';
import '../scss/claimHandler.scss'
import axios from 'axios';
import { REACT_APP_VAM_CONTEXT_MASTER, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from '../urls';
import { toast } from 'react-toastify';
import { axiosRequest } from '../service';
import { editModeOn } from '../utilFunctions';
import { functionalities } from '../consts';
import LoadingPage from '../reusableComponents/loader/loadingPage';

function claimHandler(props) {
  const {productNames} = props
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [claimHandlersList, setClaimHandlersList] = useState([])
  const [claimHandlersStateList, setClaimHandlersStateList] = useState([])
  const [claimHandlersStateListCopy, setClaimHandlersStateListCopy] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getClaimHandlersList()
  }, [])

  useEffect(() => {
    selectedProduct && getClaimsHandlerWithState(selectedProduct)
  },[selectedProduct])

  const getClaimsHandlerWithState = (selectedProduct) => {
    setIsLoading(true);
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER}/claimhandler/claimhandlersearch`,{
      "productID": selectedProduct.value
      }).then(data => {
        setIsLoading(false)
      setClaimHandlersStateList(data.data)
      setClaimHandlersStateListCopy([...data.data])
    }).catch(error => {
      setIsLoading(false)
      console.log(error)
    })
  }
  const updateClaimsHandlerWithState = () => {
    if(claimHandlersStateList.every(list => list.users.length > 0)){
      axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER}/claimhandler/createClaimHandler`,claimHandlersStateList).then(data => {
        toast.success("Claims handlers has been updated successfully.")
        setClaimHandlersStateList(data.data)
        setClaimHandlersStateListCopy([...data.data])
      }).catch(error => {
        console.log(error)
      })
    }else{
      toast.error("Please Select Claims Handler's.")
    }
  }

const getClaimHandlersList = () => {
  axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/usersData/CLAIMS_HANDLER`, {}).then(data => {
      setClaimHandlersList(data.data.map(list => {
          return {
              label: list.employeeName,
              value: list.userId
          }
      }))
  }).catch(error => {
      console.log(error)
      toast.error("Something Went Wrong.")
  })
}
const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid red",
  }),
};

  return (
    <section className="p-4">
      {isLoading && <LoadingPage kshemaLoader/>}
      {/* <h1 class="headerclaim">Claim Handler</h1> */}
      <hr className="upper_hr"/>
      {selectedProduct === null && <div className="outer-box_vendorMasters">
        <div className="row">
          <div className="col-12 co-sm-6 col-lg-4 rounded py-3">
            <h4>Select Product</h4>
            <ul type="none" className="productlist mt-4">
              {
                productNames && productNames.length > 0 && (
                  productNames.map((list,index) => (
                    <li onClick={() => setSelectedProduct(list)} className='handler-product'>{index + 1} - {list.label}</li>
                  ))
                )
              }
            </ul>
          </div>
        </div>
      </div>}

      {selectedProduct !== null && <Button onClick={() => setSelectedProduct(null)} className='claim-handler-back-button'> <i className="fa fa-arrow-left" aria-hidden="true"></i>  Back </Button>}

      {selectedProduct !== null &&
        <div>
          <p className='Select-Product'> Select Product </p>
          <input
            type="text"
            className="form-control bg-gray mt-2"
            style={{width: '40%'}}
            value={selectedProduct.label}
            disabled />

          {/* <hr className="upper_hr" /> */}
          {
            claimHandlersStateList && claimHandlersStateList.length > 0 && (
              claimHandlersStateList.map((list,index) => (
                <div className="form-group mb-3 handler-dropdown">
                  <div>
                  <label for="claimhandler-1">State</label>
                  <input type='text' className="form-control dropdown-box" name="claimhandler-1" id="claimhandler-1" value={list.state} disabled/>
                  </div>
                  <i className="fa fa-arrows-h" aria-hidden="true" style={{marginTop : 16, marginLeft : 16, marginRight : 16}}></i>
                  <div>
                  <label for="claimhandler-1">Select Handler</label>
                    <Select
                      styles={!list.users.length && customStyles}
                      className="align1 align-top align align_md dropbtn border border-danger"
                      options={claimHandlersList}
                      value={list.users ? list.users.map(list => {
                        return {
                          label: list.userName,
                          value: list.userID
                        }
                      }) : { label: "Select Claims Handler" }}
                      placeholder="Select Claims Handler"
                      isMulti={true}
                      onChange={(data) => {
                        claimHandlersStateList[index] = {...claimHandlersStateList[index], users: data ? data.map(list => {
                          return{
                            userName: list.label,
                            userID: list.value
                          }
                        }): [], productID: selectedProduct.value}
                        setClaimHandlersStateList([...claimHandlersStateList])
                      }}
                  />
                  </div>
                </div>     
              ))
            )
          }
          {editModeOn(functionalities.CLAIM_HANDLER_MASTER_TAB) && (
            <div>
              <Button onClick={()=> setClaimHandlersStateList([...claimHandlersStateListCopy])} className='claim-handler-cancel-button'>Reset</Button>
              <Button onClick={()=>updateClaimsHandlerWithState()} className='claim-handler-submit-button'>Submit</Button>
            </div>
          )}
        </div>}

    </section>
  )
}

export default claimHandler